export var BusinessTransactionType;
(function (BusinessTransactionType) {
    BusinessTransactionType["DEPOSIT"] = "DEPOSIT";
    BusinessTransactionType["WITHDRAW"] = "WITHDRAW";
    BusinessTransactionType["SWAP"] = "SWAP";
    BusinessTransactionType["REVERSAL"] = "REVERSAL";
    BusinessTransactionType["SCHEDULED"] = "SCHEDULED";
    BusinessTransactionType["SEND"] = "SEND";
})(BusinessTransactionType || (BusinessTransactionType = {}));
//# sourceMappingURL=BusinessTransactionType.js.map